<template>
    <a class="mx-2">
        <span class="form-stepper-circle">
            <span>{{ step }}</span>
        </span>
        <div class="label text-white">{{ $t(label) }}</div>
    </a>  
</template>
  
  <script>
    export default {
      data() {
        return {
          publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        }
      },
      components:{
          
      },
      props:['step','label'],
      methods:{
        
      }
    }
  </script>